import {Component} from '@angular/core';
import {HowItWorksNavComponent} from '../view/how-it-works-nav.component';

@Component({
  selector: 'bb-how-it-works-nav-mobile',
  templateUrl: './how-it-works-nav-mobile.component.html',
  styleUrls: ['./how-it-works-nav-mobile.component.scss'],
})
export class HowItWorksNavMobileComponent {
  constructor(public nav: HowItWorksNavComponent) {
  }
}
